import script from "./Happs.vue?vue&type=script&setup=true&lang=js"
export * from "./Happs.vue?vue&type=script&setup=true&lang=js"

import "./Happs.vue?vue&type=style&index=0&id=4be77c24&lang=scss&scoped=true"
script.__scopeId = "data-v-4be77c24"

export default script